import { mutation, query, proxy_api } from "@core/helpers/graphql";
import {
  GET_FAVORITE_PRODUCTS,
  GET_PRODUCTS,
  GET_PRODUCTS_FILTERS,
  GET_PRODUCTS_LITE,
  GET_PRODUCTS_OPTIMIZED,
  GET_PRODUCT_BY_SLUG,
  GET_PRODUCT_SLUG_BY_SKU,
  GET_RELATED_PRODUCTS,
  GET_SEARCH_PRODUCTS, GET_SUGGESTION_PRODUCTS_IN_CART,
} from "./_queries";
import {
  ADD_TO_CART,
  ADD_TO_FAVORITE,
  ADD_TO_NOTIFICATIONS,
  REMOVE_ALL_FROM_CART,
  REMOVE_FROM_CART,
  SYNC_LOCAL_CART,
} from "./_mutations";

export const get_product_by_slug = async (variables, options = {}) => {
  const { gql, product_page_mockup } = options;
  const result = await query(gql || GET_PRODUCT_BY_SLUG({ product_page_mockup }), variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
};

export const get_products_lite_query = async (variables, options = {}) => {
  const { gql, custom_mockup } = options
  const result = await query(gql || GET_PRODUCTS_LITE(custom_mockup), variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}

export const get_products_optimized_query = async (variables, options = {}) => {
  const { gql, custom_mockup } = options
  const result = await query(gql || GET_PRODUCTS_OPTIMIZED(custom_mockup), variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}

export const get_products_query = async (variables, options = {}) => {
  const { gql, product_card_mockup } = options;

  const result = await query(
    gql || GET_PRODUCTS({ product_card_mockup }),
    variables,
    options
  );
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
};

export const get_products_query_proxy = async (variables, options = {}) => {
  const { gql, product_card_mockup, card_model_name } = options

  if (card_model_name == "ProductModel") return await get_products_query(variables, options);

  const result = await proxy_api({
    type: 'query',
    gql: gql || GET_PRODUCTS({ product_card_mockup }),
    variables,
    options,
    cacheOptions: {
      name: 'products',
      ttl: 60 * 5,
      keys: variables
    }
  });

  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
};

export const get_products_filters_query = async (variables, options = {}) => {
  const { gql, custom_product_card_mockup, custom_blog_card_mockup, include_filters, include_products, include_blogs, include_related_links } = options;
  const result = await query(
    gql || GET_PRODUCTS_FILTERS({ custom_product_card_mockup, custom_blog_card_mockup, include_filters, include_products, include_blogs, include_related_links }),
    variables,
    options
  );
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
};

export const get_products_filters_query_proxy = async (variables, options = {}) => {
  const { gql, custom_product_card_mockup, custom_blog_card_mockup, include_filters, include_products, include_blogs, include_related_links } = options;

  const result = await proxy_api({
    type: 'query',
    gql: gql || GET_PRODUCTS_FILTERS({ custom_product_card_mockup, custom_blog_card_mockup, include_filters, include_products, include_blogs, include_related_links }),
    variables,
    options,
    cacheOptions: {
      name: 'products-filters',
      ttl: 60 * 5,
      // a query with the related links must not share the cached answer of one without them; same keys when off
      keys: include_related_links ? { ...variables, include_related_links } : variables
    }
  });

  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
};

export const get_related_products_query = async (variables, options = {}) => {
  const { gql, product_card_mockup } = options;
  const result = await query(gql || GET_RELATED_PRODUCTS({ product_card_mockup }), variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
};

export const add_to_cart_mutation = async (variables, options = {}) => {
  const { gql } = options;
  const result = await mutation(gql || ADD_TO_CART, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
};

export const sync_local_cart_mutation = async (variables, options = {}) => {
  const { gql } = options;
  const result = await mutation(gql || SYNC_LOCAL_CART, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
};

export const remove_from_cart_mutation = async (variables, options = {}) => {
  const { gql } = options;
  const result = await mutation(gql || REMOVE_FROM_CART, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
};
export const remove_all_from_cart_mutation = async (variables, options = {}) => {
  const { gql } = options;
  const result = await mutation(gql || REMOVE_ALL_FROM_CART, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
};

export const add_product_to_notification_mutation = async (
  variables,
  options = {}
) => {
  const { gql } = options;
  const result = await mutation(
    gql || ADD_TO_NOTIFICATIONS,
    variables,
    options
  );
  return {
    data: result?.addToNotifies,
    errors: result?.errors || false,
    status: result?.status || false,
  };
};

export const add_product_to_favorite_mutation = async (
  variables,
  options = {}
) => {
  const { gql } = options;
  const result = await mutation(gql || ADD_TO_FAVORITE, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
};

export const get_favorite_products_query = async (variables, options = {}) => {
  const { gql, custom_gql } = options;
  const result = await query(gql || GET_FAVORITE_PRODUCTS(custom_gql), variables, options);

  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
};

export const get_search_products_query = async (variables, options = {}) => {
  const { gql } = options;

  const result = await query(gql || GET_SEARCH_PRODUCTS, variables, options);
  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
};

export const get_product_slug_with_sku_query = async (variables, options = {}) => {
  const { gql } = options
  const result = await query(gql || GET_PRODUCT_SLUG_BY_SKU, variables, options);

  return {
    data: result?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}

export const get_suggestion_products_in_cart_query = async (variables, options = {}) => {
  const { gql } = options;
  const result = await query(gql || GET_SUGGESTION_PRODUCTS_IN_CART, variables, options);

  return {
    data: result?.data?.data,
    errors: result?.errors || false,
    status: result?.status || false,
  };
}